import { createAction } from 'redux-actions'
import axios from 'axios';

// 获得用户积分信息
export const getScoreSucceeded = createAction('score/GET_SUCCEEDED')
export const getScoreFailed = createAction('score/GET_FAILED')

export function fetchGetScore(params) {
  return dispatch => (
    axios.get('/api/find/score/list', { params })
      .then(response => dispatch(getScoreSucceeded(response)))
      .catch(error => dispatch(getScoreFailed(error)))
  )
}

// 导出用户积分信息
export const getScoreExportRequested = createAction('scoreExport/GET_REQUESTED')
export const getScoreExportSucceeded = createAction('scoreExport/GET_SUCCEEDED')
export const getScoreExportFailed = createAction('scoreExport/GET_FAILED')

export function fetchGetScoreExport(params) {
  return (dispatch) => {
    dispatch(getScoreExportRequested);
    return axios.get('/api/find/getUserScoreExcel', { params })
      .then(response => dispatch(getScoreExportSucceeded(response)))
      .catch(error => dispatch(getScoreExportFailed(error)));
  }
}



// WEBPACK FOOTER //
// ./actions/score.js